<template>
    <div class="c-start text-tundora-500 text-center font-medium italic text-4xl py-12">
        {{model.heading}}
    </div>
</template>

<script>

export default {
    props: ['model'],
};
</script>
